module.exports = __webpack_public_path__ + "img/carrusel_5.f035caf1.jpg";